"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Volume = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Volume = function Volume() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    d: "m 2,8.49989 v 6.99901 c 0,0.828 0.672,1.5 1.5,1.5 h 1.76697 c 0.474,0 0.93209,0.1679 1.29309,0.4739 L 10.251,20.6 c 1.085,0.92 2.75,0.1478 2.75,-1.2742 V 4.67201 c 0,-1.422 -1.664,-2.19317 -2.75,-1.27417 L 6.56006,6.52479 c -0.361,0.306 -0.81909,0.47413 -1.29309,0.47413 H 3.5 C 2.672,6.99992 2,7.67189 2,8.49989 Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "m 15.749802,16.99 c -0.192,0 -0.385,-0.0739 -0.531,-0.2209 -0.293,-0.293 -0.2911,-0.7691 0.0019,-1.0611 0.994,-0.99 1.542,-2.308 1.542,-3.709 0,-1.401 -0.548,-2.71894 -1.542,-3.70894 -0.293,-0.292 -0.2949,-0.76703 -0.0019,-1.06103 0.292,-0.293 0.7669,-0.29396 1.0609,-0.00196 1.279,1.273 1.983,2.96803 1.983,4.77103 0,1.803 -0.704,3.498 -1.983,4.771 -0.147,0.148 -0.3379,0.2209 -0.5299,0.2209 z m 3.36,2.6111 c 2.033,-2.028 3.1529,-4.7281 3.1529,-7.6011 0,-2.87298 -1.1199,-5.57305 -3.1529,-7.60105 -0.294,-0.293 -0.7691,-0.29202 -1.0611,9.8e-4 -0.292,0.293 -0.292,0.76803 0.002,1.06103 1.749,1.744 2.712,4.06606 2.712,6.53904 0,2.473 -0.963,4.7941 -2.712,6.5391 -0.294,0.293 -0.294,0.768 -0.002,1.061 0.146,0.147 0.339,0.22 0.531,0.22 0.192,0 0.3831,-0.073 0.5301,-0.219 z",
    fill: "currentColor"
  }));
};

exports.Volume = Volume;